import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import {
  changeActiveTab,
  getProcessDiscoverySkills,
  setSearchQuery,
} from "../../../../../redux/actions/skill";
import { changeMode } from "../../../../../redux/actions/appActions";
import EmptyLoader from "../../../../../components/emptyLoader";
import Loader from "../../../../../components/loader";
import MyDraftItem from "../MyDraftItem";
import getColors from "../../../../../components/colors";
import { Pagination, Select, Modal, Tooltip, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const ProcessDiscovery = () => {
  const [page, setPage] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [pendingPage, setPendingPage] = useState(1);
  const [publishedPage, setPublishedPage] = useState(1);
  const [draftPage, setDraftPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searching, setSearching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [createdBy, setCreatedBy] = useState("");
  const [displayContent, setDisplayContent] = useState("");
  const [checked, setChecked] = useState("all");
  const dispatch = useDispatch();
  const history = useHistory();
  const skills = useSelector(
    (state) => state.skillReducer?.processSkill?.results
  );
  const totalCount = useSelector(
    (state) => state.skillReducer?.processSkill?.filtered_total
  );
  
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const initialPage = parseInt(queryParams.get("page")) || 1;
    setActivePage(initialPage);
    fetchSkills(initialPage); // Fetch skills for the initial page
  }, []); 

  const fetchSkills = async (pageNumber) => {
    let data = { page:pageNumber, filter: "Process Discovery" };
    setIsLoading(true);
    let res = await dispatch(getProcessDiscoverySkills(data));
    setIsLoading(false);
  };
  const searchProcessSkills = (e) => {
    dispatch(setSearchQuery(e.target.value));
    setSearchTerm(e.target.value);
  };
  const onKeyPress = (e) => {
    if (e.key == "Enter") {
      setSearching(true);
      dispatch(setSearchQuery(e.target.value));
      setSearchTerm(e.target.value);
      history.push({
        pathname: `/dashboard/skills/search/draft?query=${e.target.value}`,
      });
    }
  };
  const searchBar = () => {
    return (
      <div className="row mx-0 setting-search bg-white py-3 border-left">
        <div className="col-md-8">
          <div className="position-relative search">
            <input
              id="searchField"
              type="search"
              placeholder="Search"
              className="form-control border-0"
              value={searchTerm ? searchTerm : ""}
              onChange={(e) => searchProcessSkills(e)}
              onKeyDown={(e) => onKeyPress(e)}
            />
            {/* <img src={SearchIcon} alt="Search" /> */}
          </div>
        </div>
      </div>
    );
  };

  const header = () => {
    return (
      <div className="title-btn tab-title-btn">
        {/* <h1 className="title">Created By Team</h1> */}
        <div className="title-tabs">
          <button
            className="btn btn-default "
            onClick={() => {
              dispatch(changeActiveTab("Created By Team"));

              history.push("/dashboard/skills/draft");
              dispatch(changeMode(false));
            }}
          >
            Created by Team
          </button>
          <button
            className="btn btn-default"
            onClick={() => {
              dispatch(changeActiveTab("Added From Agent Hub"));

              history.push("/dashboard/skills/published");
              dispatch(changeMode(false));
            }}
          >
            Added From Agent Hub
          </button>

          {/* Process Discovery */}
          <button
            className="btn btn-default active"
            onClick={() => {
              dispatch(changeActiveTab("Process Discovery"));

              history.push("/dashboard/skills/process-discovery");
              dispatch(changeMode(false));
            }}
          >
            Process Discovery
          </button>
        </div>

        {displayFilters()}
      </div>
    );
  };

  const handlePageChange = async (pageNumber) => {
    setActivePage(pageNumber);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber.toString()); // Setting the page parameter to the URL
    history.push({ search: queryParams.toString() });
    await fetchSkills(pageNumber);
  };

  const displayFilters = () => {
    <div className="radio-btns filter-row">
      <div className="filter-sort">
        <Select
          value={checked}
          style={{
            width: 120,
          }}
          options={[
            {
              value: "all",
              label: "Filters",
            },

            {
              value: "byUser",
              label: (
                <span data-toggle="modal" data-target="#userModal1">
                  By User
                </span>
              ),
            },
            {
              value: "published",
              label: "Published",
            },
            {
              value: "draft",
              label: "Draft",
            },
            {
              value: "pending",
              label: "Pending",
            },
          ]}
          onChange={handleSelectChange}
        />
        {displayContent ? (
          <div className="filter-badge">
            <span>{displayContent}</span>

            <Button
              onClick={() => {
                setIsLoading(false);
                setCreatedBy("");
                setDisplayContent("");
                setChecked("all");
                fetchSkills();
              }}
              shape="circle"
              icon={<CloseOutlined />}
            />
          </div>
        ) : null}
      </div>
    </div>;
  };

  const getFilteredSkill = async () => {};
  const handleSelectChange = (value) => {
    setChecked(value);
    setIsLoading(true);

    switch (value) {
      case "all":
        fetchSkills();
        break;
      case "published":
        getFilteredSkill();
        break;
      case "draft":
        getFilteredSkill();
        break;
      case "pending":
        getFilteredSkill();
        break;
      case "byUser":
        break;
      default:
        break;
    }
  };
  const displayProcessCards = () => {
    return (
      <div id="scrollableDiv" className="scrollable tl-scroll">
        {isLoading ? (
          <Loader
            styles={{ width: "80px", margin: "auto" }}
            root={{ display: "flex" }}
          />
        ) : (
          <div>
            {isLoading === false && !skills?.length ? (
              <div>
                <EmptyLoader
                  style={{ width: "30%" }}
                  message="No Agents found"
                  />
              </div>
            ) : (
              <div>
                {skills.map((item, key) => (
                  <MyDraftItem
                    color={getColors(item.SKILL_NAME)}
                    key={key}
                    skill={item}
                  />
                ))}
                <div className="template-flex">
                  <div className="template-box scrollable">
                    <Pagination
                      current={activePage}
                      pageSize={9}
                      total={totalCount}
                      onChange={handlePageChange}
                      hideOnSinglePage={false}
                      showSizeChanger={false}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="task-col-search">
      {searchBar()}
      <div className="task-col">
        {header()}
        {displayProcessCards()}
      </div>
    </div>
  );
};

export default ProcessDiscovery;
